import httpClient from '@/services/http.js'

class SubscriptionService {
  constructor() {
    const goLive = true
    this.baseURL = process.env.VUE_APP_BACKEND_URL

    if(process.env.NODE_ENV == 'development' && goLive) {
      this.baseURL = 'https://simply-studio.appspot.com'
    }
  }

  async getSubscription() {
    return httpClient.get(this.baseURL + '/subscription')
    // local dev runs into weird "token used before issued" problem
    // return httpClient.get('https://simply-studio.appspot.com/subscription')
      .then(r => r.data)
  }

  async getStripeSession(plan) {
    return httpClient.get(this.baseURL + '/stripe-session/' + plan)
      .then(r => r.data)
  }
}

export default new SubscriptionService()